export default [
    { //活动沙龙列表
        path: '/salonManagement',
        name:'salonManagement',
        meta: { title: '活动沙龙列表'},
        component: () => import('../../views/salonManagement/index.vue')
    },
    { //活动明细
        path: '/salonManagement/detail',
        name:'salonManagementDetail',
        meta: { title: '活动明细'},
        component: () => import('../../views/salonManagement/detail.vue')
    },
    { //发布活动
        path: '/salonManagement/add',
        name:'salonManagementAdd',
        meta: { title: '发布活动'},
        component: () => import('../../views/salonManagement/add.vue')
    },
    { //编辑活动
      path: '/salonManagement/edit',
      name:'salonManagementEdit',
      meta: { title: '编辑活动'},
      component: () => import('../../views/salonManagement/edit.vue')
  },
]